import Component from '@glimmer/component'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type { DataRow } from 'teacher-ui-client/components/assignments-admin/students-table'
import UiButton from 'teacher-ui-client/components/ui-button'
import { fn } from '@ember/helper'
import { on } from '@ember/modifier'
import { optional } from 'teacher-ui-client/helpers/optional'
import { t } from 'ember-intl'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { formatValue } from 'teacher-ui-client/utils/format-value'
import gradeName from 'teacher-ui-client/helpers/grade-name'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'

interface Signature {
  Args: {
    subscriptionType?: SubscriptionType
    selectedStudentId?: Nullable<string>
    row: DataRow
    goToStudentAction?: (id: string) => unknown
  }
}

export class StudentsTableRow extends Component<Signature> {
  get isSelected() {
    return this.args.selectedStudentId === this.args.row.id
  }

  get rowHoverClassNames() {
    switch (this.args.subscriptionType) {
      case SubscriptionType.Reading:
        return 'hover:bg-oceany-blue-150'
      case SubscriptionType.Maths:
        return 'hover:bg-ms-green-100'
      case SubscriptionType.Writing:
        return 'hover:bg-wl-blue-100'
      default:
        return 'hover:bg-dusty-black-100'
    }
  }

  get rowSelectedClassNames() {
    switch (this.args.subscriptionType) {
      case SubscriptionType.Reading:
        return 'bg-oceany-blue-150'
      case SubscriptionType.Maths:
        return 'bg-ms-green-100'
      default:
        return 'bg-dusty-black-100'
    }
  }

  <template>
    <tr class="{{this.rowHoverClassNames}} {{if this.isSelected this.rowSelectedClassNames}}" data-id={{@row.id}}>
      <td class="p-3">
        <UiButton
          @appearance={{ButtonAppearance.regular}}
          class="print:hidden"
          aria-label={{if
            this.isSelected
            (t "assignments.assignmentDetails.hide")
            (t "assignments.assignmentDetails.show")
          }}
          {{on "click" (fn (optional @goToStudentAction) @row.id)}}
        >
          <PhosphorIcon
            class="-mx-2"
            @icon={{if this.isSelected "phosphor-caret-down-fill" "phosphor-caret-right-fill"}}
          />
        </UiButton>
      </td>
      <td class="p-3 text-left">
        {{@row.firstName}}
      </td>
      <td class="p-3 text-left">
        {{@row.lastName}}
      </td>
      <td class="p-3 text-left" data-test-school-classes-cell>
        {{@row.schoolClassNames}}
      </td>
      <td class="p-3 text-left">
        {{formatValue (gradeName @row.gradePosition)}}
      </td>
      <td class="p-3 text-left" data-test-incomplete-count-cell>
        {{@row.incompleteCount}}
      </td>
    </tr>
  </template>
}
